import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { HiFolder } from "react-icons/hi2";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import SectionTopicHeader from "../../components/common/SectionTopicHeader";
import { routes } from "../../helper/routes";
import AssessmentLibraryFilter from "./AssessmentLibraryFilter";
import ManagePaperList from "./ManagePaperList";
import { sectionItems } from "./assessSectionData";
import "./AssessShared.css";
import "./ManagePaper.css";

export default function ManagePaperSection() {
  const history = useHistory();
  const [filteredItems, setFilteredItems] = useState(sectionItems.papers);

  const handleItemsChange = useCallback((items) => {
    setFilteredItems(items);
  }, []);

  return (
    <ContentWrapper>
      <section className="assess-section manage-paper-section">
        <SectionTopicHeader
          className="assess-topic-header"
          title="Manage Papers"
          subtitle="Manage published papers and available exam settings"
          icon={<HiFolder />}
          color="#102b46"
          colorAlt="#0d5c48"
        />
        <AssessmentLibraryFilter
          items={sectionItems.papers}
          onItemsChange={handleItemsChange}
          countLabel="Number of Papers"
          searchAriaLabel="Search papers"
          panelFirst={false}
        />
        <ManagePaperList
          items={filteredItems}
          onView={(item) =>
            history.push(routes.mng_ppr_view.replace(":id", item.id))
          }
        />
      </section>
    </ContentWrapper>
  );
}
